<template>
    <LayoutWithNav>
        <BackOnTop title="優惠券" :url="url" />
        <PopupCouponExchangeSuccess
            :togglePopup="togglePopup"
            v-model="showSuccessPopup"
        />
        <PopupCouponExchangeDuplicate
            :togglePopup="toggleDuplicatePopup"
            v-model="showDuplicatePopup"
        />
        <PopupCouponExchangeError
            :togglePopup="toggleErrorPopup"
            v-model="showErrorPopup"
        />
        <div
            class="d-flex"
            style="display:flex; justify-content: space-between; gap: 8px; padding: 0 32px; margin: 14px 0px 24px;"
        >
            <FancyInput
                v-model="coupon_code"
                searchType
                noIcon
                placeholder="輸入優惠序號"
                hide-details="true"
                hideCheck
                style="width:100%;margin: 0;"
                class="body-regular"
                @click:search="handleSearch"
            />
            <div @click="handleSearch" style="font-weight:700; font-size:14px; line-height:16.6px;letter-spacing: 4%;flex-shrink:0; height:40px; display:flex;align-items:center;border-radius:14px; padding:0px 21.5px; background-color:#FF9F4B; color:#fff;">
                兌換
            </div>
        </div>
        <div class="info_wrappper" style="width: 100%; padding: 0 32px;">
            <Tab
                style="margin-bottom: 24px;"
                :tabList="tabList"
                :currentTab="currentTab"
                @update="tabHandler"
            />
            <div class="undone_list list" v-if="currentTab === 'undone'">
                <CouponItem
                    v-for="(el, idx) in couponUndoneList"
                    :key="`undone${idx}`"
                    :data="el"
                    status="getCoupon"
                    :valid="el.valid"
                ></CouponItem>
                <div v-if="couponUndoneList.length === 0" style="margin-top: 77px;">
                    <img src="@/assets/images/nouse.png" style="width: 132px;height: 132px;">
                    <p style="color: #6F6F6F;font-family: Noto Sans TC; font-weight: 700;font-size: 16px;line-height: 19.2px;letter-spacing: 4%; text-align: center;">尚無優惠券可使用</p>
                </div>
            </div>
            <div class="done_list list" v-if="currentTab === 'done'">
                <CouponItem
                    v-for="(el, idx) in couponDoneList"
                    :key="`done${idx}`"
                    :data="el"
                    status="redeemed"
                    :valid="el.valid"
                ></CouponItem>
                <div v-if="couponDoneList.length === 0" style="margin-top: 77px;">
                    <img src="@/assets/images/nouse.png" style="width: 132px;height: 132px;">
                    <p style="color: #6F6F6F;font-family: Noto Sans TC; font-weight: 700;font-size: 16px;line-height: 19.2px;letter-spacing: 4%; text-align: center;">尚無使用優惠券</p>
                </div>
            </div>
            <div class="unget_list list" v-if="currentTab === 'unget'">
                <CouponItem
                    v-for="(el, idx) in couponUngetList"
                    :key="`unget_${idx}`"
                    :data="el"
                    status="counting"
                ></CouponItem>
                <div v-if="couponUngetList.length === 0" style="margin-top: 77px;">
                    <img src="@/assets/images/nouse.png" style="width: 132px;height: 132px;">
                    <p style="color: #6F6F6F;font-family: Noto Sans TC; font-weight: 700;font-size: 16px;line-height: 19.2px;letter-spacing: 4%; text-align: center;">尚無過期優惠券</p>
                </div>
            </div>
        </div>
    </LayoutWithNav>
</template>

<script>
import BackOnTop from '@/components/BackOnTop.vue';
import LayoutWithNav from '@/layouts/LayoutWithNav.vue';
import Tab from '@/components/Tab.vue';
import CouponItem from '@/components/CouponItem.vue';
import PopupCouponExchangeSuccess from '@/components/Popup/PopupCouponExchangeSuccess.vue';
import PopupCouponExchangeDuplicate from '@/components/Popup/PopupCouponExchangeDuplicate.vue';
import PopupCouponExchangeError from '@/components/Popup/PopupCouponExchangeError.vue';
import FancyInput from '@/components/FancyInput.vue';
import {
    getCouponList,
    getPersonalCouponList,
    useCodeGetCoupon,
} from '@/apis/api.js';
export default {
    name: 'CouponIndex',
    components: {
        BackOnTop,
        LayoutWithNav,
        Tab,
        CouponItem,
        FancyInput,
        PopupCouponExchangeSuccess,
        PopupCouponExchangeDuplicate,
        PopupCouponExchangeError,
    },
    data: () => ({
        showSuccessPopup: false,
        showDuplicatePopup: false,
        showErrorPopup: false,
        coupon_code: '',
        tabList: [
            {
                name: '可使用',
                value: 'undone',
            },
            {
                name: '已使用',
                value: 'done',
            },
            {
                name: '已過期',
                value: 'unget',
            },
        ],
        currentTab: 'undone',
        couponUngetList: [],
        couponUndoneList: [],
        couponDoneList: [],
        url: '/',
    }),
    beforeCreate() {
        this.$store.state.isLoading = true;
    },
    created() {
        if (
            !localStorage.getItem('phone') ||
            !localStorage.getItem('password') ||
            !localStorage.getItem('member_no')
        ) {
            this.$router.push('/login');
        } else {
            if (this.$route.query.type == 'unget') this.currentTab = 'unget';
            else if (this.$route.query.type == 'use') this.currentTab = 'undone';
            else if (this.$route.query.type == 'done') this.currentTab = 'done';

            this.getCouponList();
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$store.state.isLoading = false;
        });
    },
    methods: {
        handleSearch(){
            this.exchangeCoupon()
        },
        getCouponList() {
            let parent = this;
            var newDateObj = new Date();
            var today =
                newDateObj.getFullYear().toString() +
                (newDateObj.getMonth() + 1 < 10
                    ? '0' + (newDateObj.getMonth() + 1).toString()
                    : newDateObj.getMonth() + 1
                ).toString() +
                (newDateObj.getDate() < 10
                    ? ('0' + newDateObj.getDate()).toString()
                    : newDateObj.getDate()
                ).toString();

            getCouponList(
                localStorage.getItem('phone'),
                localStorage.getItem('password')
            ).then(function (all_coupon_list) {
                if (all_coupon_list.length && all_coupon_list) {
                    parent.couponUngetList = [];
                    parent.couponUndoneList = [];
                    parent.couponDoneList = [];
                    getPersonalCouponList(
                        localStorage.getItem('phone'),
                        localStorage.getItem('password')
                    ).then(function (personal_coupon_list) {
                        console.log(all_coupon_list, personal_coupon_list);
                        for (let i in all_coupon_list) {
                            for (let j in personal_coupon_list) {
                                if (
                                    all_coupon_list[i].tNo ==
                                    personal_coupon_list[j].tNo
                                ) {
                                    all_coupon_list[i].endDate =
                                        personal_coupon_list[j].endDate;
                                }
                            }
                        }
                        let per_check_index = [];
                        for (let i in all_coupon_list) {
                            var endDateTime = new Date(
                                all_coupon_list[i].endDate.slice(0, 4) +
                                    '/' +
                                    all_coupon_list[i].endDate.slice(4, 6) +
                                    '/' +
                                    all_coupon_list[i].endDate.slice(6, 8)
                            ).getTime();
                            var nowDateTime = new Date().getTime();
                            var expired_days =
                                (nowDateTime - endDateTime) /
                                (1000 * 60 * 60 * 24);
                            // console.log(all_coupon_list[i].title, expired_days);
                            if (
                                all_coupon_list[i].startDate <= today &&
                                all_coupon_list[i].endDate >= today
                            ) {
                                var have = false;
                                all_coupon_list[i].type = '優惠票卷';
                                for (let j in personal_coupon_list) {
                                    if (
                                        per_check_index.indexOf(j) == -1 &&
                                        all_coupon_list[i].tNo ==
                                            personal_coupon_list[j].tNo
                                    ) {
                                        have = true;
                                        per_check_index.push(j);
                                        console.log(
                                            'per_check_index',
                                            per_check_index
                                        );
                                        if (
                                            personal_coupon_list[j].isUse == '1'
                                        ) {
                                            all_coupon_list[i].endDate = personal_coupon_list[j].endDate;
                                            parent.couponDoneList.push(
                                                all_coupon_list[i]
                                            );
                                        } else {
                                            console.log('match', j);
                                            all_coupon_list[i].endDate =
                                                personal_coupon_list[j].endDate;
                                            all_coupon_list[i].pcid =
                                                personal_coupon_list[j].pcid;
                                            let temp_coupon = JSON.parse(
                                                JSON.stringify(
                                                    all_coupon_list[i]
                                                )
                                            );
                                            temp_coupon.index = j;
                                            parent.couponUndoneList.push(
                                                temp_coupon
                                            );
                                        }
                                    }
                                    if (j == personal_coupon_list.length - 1) {
                                        if (
                                            !have &&
                                            all_coupon_list[i].isvisible !=
                                                'False'
                                        )
                                            if(expired_days >= 1){
                                                parent.couponUngetList.push(
                                                    all_coupon_list[i]
                                                );
                                            }else{
                                                parent.couponUndoneList.push(
                                                    all_coupon_list[i]
                                                );
                                            }
                                    }
                                }
                                if (
                                    (!personal_coupon_list.length ||
                                        !personal_coupon_list) &&
                                    all_coupon_list[i].isvisible != 'False'
                                )
                                    parent.couponUngetList.push(
                                        all_coupon_list[i]
                                    );
                            } else if (all_coupon_list[i].endDate < today) {
                                have = false;
                                all_coupon_list[i].type = '優惠票卷';
                                for (let j in personal_coupon_list) {
                                    if (
                                        all_coupon_list[i].tNo ==
                                        personal_coupon_list[j].tNo
                                    ) {
                                        if (
                                            personal_coupon_list[j].isUse == '1'
                                        ) {
                                            // 領取並用過且過期
                                            have = true;
                                            all_coupon_list[i].valid = '';
                                            all_coupon_list[i].endDate =
                                                personal_coupon_list[j].endDate;
                                            parent.couponUngetList.push(
                                                all_coupon_list[i]
                                            );
                                        } else {
                                            // 領取沒用過且過期
                                            have = true;
                                            all_coupon_list[i].valid =
                                                'expired';
                                            all_coupon_list[i].endDate =
                                                personal_coupon_list[j].endDate;
                                            if (expired_days < 30)
                                                parent.couponUngetList.push(
                                                    all_coupon_list[i]
                                                );
                                        }
                                    }
                                    if (j == personal_coupon_list.length - 1) {
                                        if (
                                            !have &&
                                            all_coupon_list[i].isvisible !=
                                                'False'
                                        ) {
                                            // 未領取且過期
                                            all_coupon_list[i].valid =
                                                'expired';
                                            if (expired_days < 30)
                                                parent.couponUngetList.push(
                                                    all_coupon_list[i]
                                                );
                                        }
                                    }
                                }
                                if (
                                    (!personal_coupon_list.length ||
                                        !personal_coupon_list) &&
                                    all_coupon_list[i].isvisible != 'False'
                                ) {
                                    all_coupon_list[i].valid = 'expired';
                                    if (expired_days < 30)
                                        parent.couponDoneList.push(
                                            all_coupon_list[i]
                                        );
                                }
                            }
                            if (i == all_coupon_list.length - 1) {
                                parent.couponUngetList.sort(function (a, b) {
                                    return (
                                        b.create_time
                                            .replace('T', '')
                                            .replace(/:/g, '') -
                                        a.create_time
                                            .replace('T', '')
                                            .replace(/:/g, '')
                                    );
                                });
                                parent.couponUndoneList = JSON.parse(
                                    JSON.stringify(parent.couponUndoneList)
                                ).sort(function (a, b) {
                                    return (
                                        parseInt(b.index) - parseInt(a.index)
                                    );
                                });
                                console.log(
                                    'parent.couponUndoneList',
                                    parent.couponUndoneList
                                );
                                parent.couponDoneList.sort(function (a, b) {
                                    return (
                                        b.create_time
                                            .replace('T', '')
                                            .replace(/:/g, '') -
                                        a.create_time
                                            .replace('T', '')
                                            .replace(/:/g, '')
                                    );
                                });
                            }
                        }
                    });
                }
            });
        },
        togglePopup(mode) {
            this.showSuccessPopup = false;
            if (mode == 'undone') {
                this.tabHandler('undone');
            }
        },
        toggleDuplicatePopup(mode) {
            this.showDuplicatePopup = false;
            if (mode == 'undone') {
                this.tabHandler('undone');
            }
        },
        toggleErrorPopup() {
            this.showErrorPopup = false;
        },
        exchangeCoupon() {
            console.log('exchangeCoupon');
            const parent = this;
            // 兌換
            if (this.coupon_code) {
                useCodeGetCoupon(
                    localStorage.getItem('phone'),
                    localStorage.getItem('password'),
                    this.coupon_code
                ).then(function (rsp) {
                    console.log(rsp);
                    rsp = JSON.parse(rsp);
                    if (rsp.status === '0') {
                        // success???
                        parent.getCouponList();
                        parent.showSuccessPopup = true;
                        parent.coupon_code = ''
                    } else if (
                        rsp.status === '1' &&
                        rsp.message.match('already') != null
                    ) {
                        parent.showDuplicatePopup = true;
                    } else {
                        parent.showErrorPopup = true;
                    }
                });
            } else {
                parent.showErrorPopup = true;
            }
        },
        tabHandler(value) {
            this.currentTab = value;
        },
    },
    watch: {

    }
};
</script>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
h2 {
    color: $color_main_first;
    font-size: 26px;
    font-weight: bold;
    padding: 12px 16px;
    line-height: 1;
    text-align: left;
}
</style>
